import { getQueryStringByName } from '@/utils';
import { useEffect } from 'react';
import { useStore } from '@/store';


export default function useCinemaCurrencySign() {
  const { cinemaCurrencySign, fetchCinemaCurrencySign } = useStore();

  useEffect(() => {
    const wapid = getQueryStringByName('wapid');
    const cinemaId = getQueryStringByName('cinemaId');
    if (wapid && cinemaId) {
      fetchCinemaCurrencySign(`key_${wapid}_${cinemaId}`, wapid, cinemaId);
    }
  }, []);

  return {
    cinemaCurrencySign,
  };
}
